import { combineReducers } from '@reduxjs/toolkit';
import applicationList, { AllApplicationsState } from './AllApplicationsReducer';

export type ApplicationListState = { applicationList: AllApplicationsState };

const AllApplicationsReducer = combineReducers({
  applicationList,
});

export default AllApplicationsReducer;
